module.exports = __webpack_public_path__ + "static/img/concept_page2.856972eb.jpg";